import axios from "axios";
import { setupCache } from "axios-cache-interceptor";
import localforage from "localforage";
import localforageMemoryStorageDriver from "localforage-memoryStorageDriver";
import { unEscapeStr, getFileHeaders, getHeaders } from "../utils/helper";
import endpoints from "./endpoints";

const configureAxios = async () => {
  await localforage.defineDriver(localforageMemoryStorageDriver);

  const forageStore = localforage.createInstance({
    driver: [
      localforage.INDEXEDDB,
      localforage.LOCALSTORAGE,
      localforageMemoryStorageDriver._driver,
    ],
    name: "hrms-cache",
  });

  // ✅ Create an Axios instance first
  const api = axios.create({
    headers: getHeaders(),
  });

  // ✅ Properly set up cache with the instance
  setupCache(api, {
    ttl: 3600 * 60 * 1000, // Cache expiry (1 hour)
    store: forageStore,
  });

  return api;
};

// ✅ Function to fetch file/image
export const getFileOrImage = async (data) => {
  const api = await configureAxios();

  return api({
    url: endpoints.fileOrImage,
    method: "get",
    headers: getHeaders(),
    params: { ...data, fileUrl: unEscapeStr(data.fileUrl) },
    responseType: "blob",
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response?.status,
    }));
};

// ✅ Function to upload a file
export const uploadFile = async (data, onUploadProgress = () => {}) => {
  return axios({
    url: endpoints.file,
    method: "post",
    data,
    onUploadProgress,
    headers: getFileHeaders(),
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response?.status,
    }));
};

// ✅ Function to upload an image
export const uploadImage = async (data, onUploadProgress = () => {}) => {
  return axios({
    url: endpoints.image,
    method: "post",
    data,
    onUploadProgress,
    headers: getFileHeaders(),
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response?.status,
    }));
};

// ✅ Function to delete a file/image
export const deletefileOrImage = async (src) => {
  return axios({
    url: endpoints.fileOrImage,
    method: "delete",
    headers: getHeaders(),
    data: { fileUrl: src },
  })
    .then((response) => response.data)
    .catch((err) => ({
      status: 0,
      response: err.response,
      code: err.response?.status,
    }));
};
